import script from "./ChemicalInventoryPerformancePieChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ChemicalInventoryPerformancePieChart.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__